import openLink from '../../../assets/icons/open-link.svg';
import TrashIcon from 'assets/icons/TrashIcon';
import React from 'react';
import { EditIcon } from 'assets/icons/Edit';
import { INew } from '../types';
import { useNewsStore } from '../store';

export const NewItemCard = ({
  newItem,
  setIsDeleteModalOpen,
  setIdToDelete,
}: {
  newItem: INew;
  setIsDeleteModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setIdToDelete: React.Dispatch<React.SetStateAction<string>>;
}) => {
  const { setNewEdit } = useNewsStore();
  return (
    <>
      <img
        src={`${newItem.image}`}
        className='min-w-[40px] w-[80px] h-[80px] object-cover'
        alt=''
      />

      <h2
        style={{
          wordBreak: 'break-word',
          overflowWrap: 'break-word',
          whiteSpace: 'normal',
        }}
        className='text-[18px] font-[500] leading-[24px] text-left'
      >
        {newItem?.title}
      </h2>

      <span className='text-[14px] font-[500] leading-[18px] text-[#DADADA99] break-all'>
        {newItem.description.split('\n').map((paragraph) => (
          <p>
            {paragraph.split(' ').map((word, index) => (
              <span
                key={index}
                className={
                  word.length > 35
                    ? 'break-words break-all whitespace-normal'
                    : ''
                }
              >
                {word}
                {index < newItem.description.split(' ').length - 1 && ' '}
              </span>
            ))}
          </p>
        ))}
      </span>

      <div className='flex mt-auto items-center'>
        <div className='ms-auto flex items-center gap-[16px]'>
          {!!newItem.link && (
            <a
              href={newItem.link}
              target='_blank'
              rel='noopener noreferrer'
              aria-label='X (Twitter)'
              className='flex justify-center items-center w-[16px] h-[16px]'
              style={{ textDecoration: 'none' }}
              onClick={(e) => e.stopPropagation()}
            >
              <img src={openLink} alt='' />
            </a>
          )}
        </div>
      </div>

      <div className='absolute top-0 right-0 flex gap-[8px] bg-[#111111] pl-2 pb-2'>
        <button
          className='dapp-page--grid-item--action'
          aria-label='Open'
          onClick={(e) => {
            e.stopPropagation();
            setNewEdit(newItem);
          }}
        >
          <EditIcon width={14} height={14} />
        </button>

        <button
          className='dapp-page--grid-item--action-delete'
          aria-label='Open'
          onClick={(e) => {
            e.stopPropagation();
            setIdToDelete(newItem.id);
            setIsDeleteModalOpen(true);
          }}
        >
          <TrashIcon width={16} height={16} />
        </button>
      </div>
    </>
  );
};
